export default __webpack_public_path__ + "static/media/TUZLA_KART_SOZLESME.685fcc80.docx";